import { pagesText } from '../../../constants/pagesText';

export const columnsOrder = ['checkbox', 'email', 'status'];

export const headings = [
  {
    title: '',
    name: 'checkbox',
    width: '10%',
  },
  {
    title: pagesText.companyUsers.headings.email,
    name: 'email',
    width: '40%',
  },
  {
    title: pagesText.companyUsers.headings.status,
    name: 'status',
    width: '28%',
  },
];

export const statusActionTypes = {
  active: 'Activate',
  suspended: 'Suspend',
};

export const statusTypes = {
  active: 'Active',
  suspended: 'Suspended',
};

export const ROW_PER_PAGE_OPTIONS = [5, 10, 25, 50, 100];
